import { Base } from 'zf-web-components';
import styles from './index.module.less';
import type { ReactElement } from 'react';

export function ShoteyesAgreementPage(): ReactElement {
  return (
    <Base.Layout className={styles.agreementContainer}>
      <div className={styles.container}>
        <h2 className={styles.title}>巡店助手用户协议</h2>
        <hr className={styles.divider} />
        <h3>
          1.前言
        </h3>
        <div>
          1.1 欢迎使用由<b>字符科技（大连）有限公司及其关联方</b>（以下简称“巡店助手”或“我们”）合法拥有并运营的巡店助手产品及服务。

          1.2
          巡店助手是一个助力企业标准化管理落实的平台，包括各版本客户端应用程序、小程序以及域名为<b>alphabets.cn</b>的网站。巡店助手相关网站、服务、产品、应用程序与内容，在《巡店助手用户协议》（以下简称“本协议”）中统称为“本服务”。授权用户和客户统称为“你”。

          1.3 本协议为你与我们之间的有效协议，规定了你下载、安装、登录、使用（统称“使用”）本服务时须遵循的条款与条件。你使用本服务即表示你确认，你具备履行本协议的完整的民事权利能力和民事行为能力；否则，你不应使用本服务。

          1.4
          请你在使用本服务之前，仔细阅读并充分理解本协议。本协议的免除或者限制责任条款等重要内容将以加粗形式提示你注意，你应重点阅读。若你是未满18周岁的自然人，请你在法定监护人陪同下仔细阅读并充分理解本协议，并征得法定监护人的同意后使用本服务。
        </div>

        <h3>2.授权用户与客户</h3>
        <div>
          2.1 你使用本服务时，仅有两种身份，即授权用户及客户。相关定义如下：

          （1）授权用户，指被客户授权或邀请加入客户在巡店助手搭建的组织架构，并使用本服务的自然人，包括团队创建人、管理员。其中，经客户指定，代客户配置本服务、行使后台管理权限的自然人称为管理员（为免歧义，本隐私政策中称为“客户管理员”）；最初代表客户创建团队的，称为团队创建人。

          （2）客户，指通过授权自然人开通本服务帐号，搭建组织架构并享有管理权限的法人或其他组织，客户可以邀请个人加入其组织成为其授权用户。

          2.2
          你同意，除了邀请你使用本服务的客户的工作人员之外，你不会与任何人分享任何授权方式下提供的信息。你亦同意，为使你及客户的其他授权用户能够享受本服务的部分功能，该客户可能向我们及客户的其他授权用户提供你的信息。该客户收集、使用、共享你信息的行为应遵守相关法律法规要求，我们仅根据客户要求处理你的信息，且不对该客户的相关行为承担法律责任。授权用户的个人信息及用户内容的相关处理请你详细查阅<a href='./privacy' className={styles.underLine}>《巡店助手隐私政策》</a>。

          2.3
          作为授权用户，客户将对你的授权用户身份及基于该身份的相关权益进行管理，包括但不限于加入、删除以及调整权限和限制服务内容等，你保证在遵守本服务相关规范的同时，按照该客户的授权范围和规范使用本服务，如你丧失授权用户身份，我们有权根据客户的指示将基于该身份的服务内容一并删除或转移。请你知悉，客户应独自负责将所有与你使用本服务有关的客户政策和惯例，以及可能影响、限制你使用本服务或访问客户数据的设置向你进行充分说明与告知，我们不就此承担任何责任。

          2.4 针对授权用户使用本服务的情况，若本协议与我们与客户所订立的其他协议规定有所冲突，则以其他协议为准。若你是以授权用户或外包厂商身份使用本服务的，你理解本服务为客户使用的职场工具性质，并非个人消费使用性质。

          2.5
          如果你代表客户开通本服务，你承诺已获得客户的充分授权，授权你代表其接受、履行本协议的全部内容。在此情况下，客户将对你使用本服务产生的各项行为在法律和财务方面承担责任。若客户就使用本服务与巡店助手另行达成其他协议，且本协议与其他协议内容有冲突的，相关内容以另行达成的其他协议为准。本协议未提及的内容，以其他协议约定为准。
        </div>

        <h3>
          3.关于帐号
        </h3>
        3.1 帐号开通
        3.1.1
        巡店助手不提供对外注册功能，客户通过授权自然人（即创建人）开通本服务之后方可使用。你有权选择合法且符合本服务要求的字符组合作为自己帐号的名称，并可对帐号自行设置符合安全要求的密码。你设置的帐号、密码是你登录使用本服务及我们提供的其他软件及相关服务的凭证。请务必维护并按时更新你的个人信息以及其他提供给我们的数据，确保数据完整且符合现况。
        3.1.2
        客户通过授权自然人（即创建人）开通本服务后，可以设置不同后台管理系统管理权限的客户管理员，客户管理员可以有一人或多人，具体可由客户及已有的客户管理员自行设定。客户管理员可在本服务上传、管理及维护授权用户的通讯录信息或其他相关信息，并可以邀请成员加入，实现巡店、协同、组织架构管理、用户权限调整等各类功能。客户获取前述信息的行为应由客户自行向授权用户告知并获得授权用户同意，我们不就客户行为承担责任。
        3.1.3
        你理解并承诺，你设置的帐号不得违反国家法律法规及本服务相关规则，你的帐号名称和简介等用于使用本服务的信息及其他向我们提供的信息中不得出现违法或不良信息，未经他人许可不得使用他人名义（包括但不限于通过冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开通帐号，不得恶意开通帐号。你在帐号使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益或者有害社会良好道德风尚的行为。我们有权对你提交的开通信息进行审核，对于违反本条款约定的开通信息，我们有权视情况采取不予开通、屏蔽或删除违法违规内容、不经通知暂停使用、冻结帐号、注销或收回帐号等措施，你应自行承担因此导致不能使用帐号或与之相关的服务与功能所造成的损失。
        3.1.4 部分服务无需帐号即可访问，你同意使用此类服务时，亦遵守本协议约定。

        3.2 帐号使用与安全
        3.2.1 <b>你了解并同意，本服务帐号所有权及有关权益均归我们所有，完成首次登录后你将获得该帐号的使用权。你的帐号仅限本人使用，未经我们书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用。</b>
        3.2.2
        <b>你有责任维护帐号、密码的安全性与保密性，在任何情况下不向他人透露，若发现他人未经许可使用你的帐号或发生其他任何安全漏洞问题时，你应当立即通知我们。</b>在丢失帐号或遗忘密码时，你可遵照我们提供的申诉途径及时申诉请求找回帐号或密码。你理解并认可，密码找回机制仅识别申诉单上所填资料与系统记录资料是否一致，而无法识别申诉人是否为帐号真正有权使用者。如有涉嫌借款、投融资、理财或其他涉及财产的网络信息、账户密码、广告或推广等信息的，请你谨慎对待并自行进行判断。
        3.2.3
        <b>你充分了解并同意，你应为自己帐号下的一切行为负责，包括该帐号所发表的任何内容以及由此产生的任何后果。</b>你应对使用本服务时接触到的内容自行加以判断，并承担因使用内容而引起的所有风险，包括因对内容的正确性、完整性或实用性的依赖而产生的风险。我们无法且不会对你因前述风险而导致的任何损失或损害承担责任。
        3.2.4
        在你完成帐号的开通、登录并进行合理和必要的身份验证后，如你是授权用户，你需要通过客户的管理员修改已经提交的身份信息。你理解并同意，出于安全性和身份识别（如帐号或密码找回申诉服务等）的考虑，你可能无法修改开通时提供的初始开通信息及其他验证信息。

        3.3 帐号冻结
        你的帐号在如下情况可能被冻结或被限制全部或部分权限、功能：
        （1）违反适用的法律、法规、政策、法律文书的规定的；
        （2）国家有权机关（包括但不限于法院、检察机关、公安机关等）要求进行冻结的；
        （3）基于本服务运行和交易安全的需要，如你发生或可能发生破坏或试图破坏我们及关联公司公平交易环境或正常交易秩序的，或任何使用含有我们及关联公司名称、品牌且对他人有误导嫌疑或任何使用某种中英文(全称或简称)、数字、域名等意图表示或映射与我们及关联公司具有某种关联的；
        （4）你遭到他人投诉，且对方已经提供了相关证据，而你未按照我们的要求提供相反证据的；
        （5）我们根据合理分析判断你的帐号操作、收益、兑换等存在异常的；
        （6）帐号归属存在争议的；
        （7）违反本协议、规则以及其他相关协议的；
        （8）我们合理判断，你发生与如上行为性质相同或产生如上类似风险的其他情况的。

        3.4 帐号注销
        3.4.1 在需要终止使用本服务时，你可以申请注销账号，但你仍应对你在注销帐号前使用本服务期间的行为承担相应责任。
        3.4.2 你知悉并理解，<b>注销帐号的行为是不可逆的行为，</b>在你的帐号被注销后，我们将删除有关你的相关信息或进行匿名化处理，但法律法规另有规定或根据客户需要就企业控制的数据另行处理的除外。
        3.4.3
        我们保留在你违反适用法律法规规定或违反本协议的情况下冻结、注销你的帐号并删除或匿名化处理你所存储的数据、文件的权利，且无需为此向你承担任何责任，由此带来的因你使用本服务产生的全部数据、信息等被清空、丢失等的损失，你应自行承担。

        <h3>
          4.你访问与使用本服务之权利
        </h3>
        4.1
        在本协议约定的条款与条件范围内，我们授予你访问、使用本服务，并访问巡店助手内容（详见第9条定义）的权利，巡店助手内容仅可通过使用本服务访问。此授权为非独家、有限、不可转让、不可分许可且可撤销的授权。巡店助手保留一切与本服务、巡店助手内容相关的权利。若未事先取得我们（或我们的授权方）书面同意，你不得为任何目的以任何形式对本服务及巡店助手内容进行包括但不限于复制、改编、重制、分发、传送、广播、展示、销售、授权，垂直搜索、镜像或其他未经授权的访问与使用。
        4.2
        我们可能不时提供试用服务或功能，并向不特定客户或受邀请客户提供。你理解并同意，试用服务将按“现状”和“当前可用”的形式提供。对试用服务在法律允许范围内我们可能仅提供有限的或在一些情形下不会提供技术支持，我们也可能在不另行通知的情况下随时更改或者停止提供试用服务；你理解我们没有义务最终发布或发售任何试用产品、服务或将其与现有产品组合为你提供服务。
        4.3 你理解并认可，本协议中所描述的功能可能仅对部分用户提供，或以特定的方式（如有偿付费）提供，你在访问和使用本服务时能够实际享受的服务以我们实际向你提供的内容为准。
        4.4
        为提升用户体验、满足用户新需求、保证产品及服务的安全性和稳定性，或基于法律和监管要求，我们将不定期进行软件更新或改变（包括但不限于修改、升级、迁移、开发新功能、变更、暂停或取消某种功能），对本服务、系统、软件等进行检修、维护，本服务可能因前述原因在合理时间内中断或暂停，你同意，我们无需为此向你承担责任。在可能的情况下，我们将尽可能以合理的方式就前述事宜通知你。若因不可抗力、基础运营商等原因导致的非常规维护，我们会在该等事件发生后尽可能以合理方式通知你。

        <h3>
          5.用户使用规范
        </h3>
        5.1 行为要求
        你应正确配置和使用本服务，并自行采取一定的安全性措施，对你的内容进行保护和备份。你声明并保证你接入本服务的算法、模型、数据、产品、服务的安全性、稳定性、有效性，不包含任何其他软件程序，不存在病毒、蠕虫、木马和其他有害的计算机的代码、文件、脚本和程序，也不存在任何一项恶意软件特征，不会对我们和/或其关联方的相关系统造成损害，亦不会对我们和/或其关联方或其他第三方数据造成损害。由于你的内容引起的安全漏洞，包括但不限于病毒、木马、蠕虫或其他有害程序，或由于你未按照本协议约定使用服务而引起的安全漏洞，由你自行负责并承担责任。
        你使用本服务不得：
        5.1.1
        <b>使用未经我们授权或许可的任何插件、外挂、系统、程序或第三方工具对本服务的正常运行进行干扰、破坏、修改或施加其他影响，包括但不限于使用自动化脚本等方式收集来自本服务的信息或与本服务互动、大量占用本服务系统或者网络带宽资源，给本服务系统或者使用本服务的其他用户的网络、服务器、产品或应用带来严重负荷，影响系统通畅。</b>
        5.1.2<b>利用或针对本服务进行任何危害计算机网络安全的行为，包括但不限于：</b>
        （1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；
        （2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；
        （3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；
        （4）使用未经许可的数据或进入未经许可的服务器/帐号；
        （5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；
        （6）未经许可，企图探查、扫描、测试本服务系统或网络的弱点或其它实施破坏网络安全的行为；
        （7）企图干涉、破坏本服务系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
        （8）伪造TCP/IP数据包名称或部分名称；
        （9）复制、模仿、修改、翻译、改编、出借、出售、转许可、在信息网络上传播或转让相关服务，或对本服务及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现本服务的源代码；
        （10）恶意开通巡店助手帐号，包括但不限于频繁、批量开通帐号；
        （11）违反法律、法规、协议、我们的相关规则及侵犯他人合法权益的其他行为。
        5.1.3 <b>将本服务用于广告目的或进行任何商业推销或复制、经销、许可、转让、租赁或出售本服务的全部或部分。</b>
        5.1.4 <b>绕过我们可能用于阻止或限制访问服务的任何措施。</b>
        5.1.5 <b>将本服务或其任何部分纳入任何其他程序或产品。</b>
        5.1.6 <b>冒充他人或其他组织机构，或对你自己的身份或你与他人或其他组织机构的关系作出虚假或不当的陈述，包括给人以你上传、发布、传播、散布或提供的任何内容是出自本服务的印象。</b>
        5.1.7 <b>未经我们授权而使用或试图使用他人的帐号、服务或系统，或在本服务创建一个虚假身份。</b>
        5.1.8 <b>超出正常好友或用户之间信息沟通、交流等目的（包括但不限于为发送广告、垃圾、骚扰或违法违规等信息的目的），通过自己添加或诱导他人添加等任何方式使自己与其他用户形成好友关系。</b>
        5.1.9 <b>将本服务用于操作核设施、飞机导航和通讯系统、空中交通管制、生命支持系统、武器系统等类似的高风险场景或某些特定目的。如果你将本服务用于高风险场景而导致人员伤亡、财产损失或环境破坏，巡店助手不承担责任。</b>
        5.1.10 <b>进行违反法律法规、本规范、巡店助手的相关规则及侵犯他人合法权益的其他行为。</b>
        5.2 信息内容规范
        5.2.1
        你使用本服务开发、制作、利用、上传、评论、发布、传播、存储、分享的内容（包括但不限于上传至本服务的未公开分享的内容）应自觉遵守相关法律法规，否则我们有权立即采取相应处理措施。你不得利用本服务制作、复制、存储、发表、传播下列信息：
        （1）反对宪法确定的基本原则的；
        （2）危害国家安全，泄露国家秘密的；
        （3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；
        （4）损害国家荣誉和利益的；
        （5）宣扬恐怖主义、极端主义的；
        （6）宣扬民族仇恨、民族歧视，破坏民族团结的；
        （7）煽动地域歧视、地域仇恨的；
        （8）破坏国家宗教政策，宣扬邪教和封建迷信的；
        （9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；
        （10）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；
        （11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；
        （12）侮辱或者诽谤他人，侵害他人合法权益的；
        （13）对他人进行暴力恐吓、威胁，实施人肉搜索的；
        （14）歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的；
        （15）散布污言秽语，损害社会公序良俗的；
        （16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；
        （17）任何未经我们或接收方同意的广告、招揽推广材料、“垃圾邮件”、“垃圾短信”、“连锁信”、“传销”或任何其它被禁止的招揽形式内容；
        （18）侵害未成年人合法权益或者损害未成年人身心健康的；
        （19）其他违反法律法规、公共政策、社会治安及公序良俗、干扰本服务正常运营或侵犯其他用户或第三方合法权益内容的其他信息。
        5.3 如果我们发现或收到他人举报或投诉用户违反本协议约定的，我们有权不经通知随时对相关内容进行删除、屏蔽，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、帐号封禁直至注销的处罚，并公告处理结果。

        <h3>
          6.第三方产品及服务
        </h3>
        6.1
        我们允许第三方应用接入巡店助手开放平台向你提供服务，你可以在工作台中通过添加应用的方式使用这类第三方服务。我们亦会与第三方合作，由第三方向你提供某些功能或服务，例如本服务中可能包含能跳转其他在线服务或资源的链接。在使用第三方服务的过程中，你除需遵守本协议的约定外，还需遵守第三方的用户协议、隐私政策等相关条款。你理解并认可，第三方服务由第三方服务方提供，除法律法规和本条款另有规定外，我们不对第三方服务承担任何责任。
        6.2 你了解并同意，我们可能会对本服务及第三方应用政策及服务作出调整，该等调整可能会对我们或第三方的服务产生影响（如导致相关服务无法继续在本服务提供，或第三方应用的服务功能受限），除法律另有明确规定外，我们不承担相应责任。
        6.3
        你在选择使用第三方服务前应充分了解第三方产品或服务的功能、服务协议及隐私政策，再选择是否开通第三方服务。如你为客户的管理员，并基于客户授权选择开通第三方服务，在你开通第三方服务并向第三方服务提供方提供含有授权用户个人信息的数据（例如客户通讯录信息）前，客户及你应向所涉及的授权用户充分说明情况并取得授权用户的明确同意。
        6.4
        本服务中可能包含能跳转其它在线服务或资源的链接，该等在线服务或资源可能是由第三方服务提供方提供。我们无法控制你对该等第三方服务或资源的使用，因此除非本协议另有约定，你使用第三方服务或资源的行为受你和相关第三方之间协议约束，我们不对你使用第三方服务或资源的行为承担任何责任。该等链接的存在不代表我们认可这些第三方服务或资源的合法性、安全性。

        <h3>
          7.用户内容
        </h3>
        7.1
        本服务允许你上传、创作或发送数字信息或材料（简称“用户内容”）。你亦可在用户内容上覆盖或增加我们提供的图案、贴纸、虚拟头像等其他元素。你承诺并保证，你拥有你上传、存储到本服务或通过本服务共享的你的内容的所有必要权利或已经获得合法授权，我们使用、展示和保留你的内容不会违反任何法律和他人的合法权利。我们不对你的内容及他人使用本服务上传、存储或共享的你的内容承担任何责任。
        7.2
        如果你与本服务的其他用户分享你的用户内容，即表示你同意向这些用户授予不受限制且免费使用你用户内容的权利（包括任何知识产权等相关权益），除非你明确地向对方说明了该等限制，但该等说明及限制仅能约束你与对方。你承诺仅向本服务或通过本服务上传、传播、提供及分享你愿意并能够授予上述权利的用户内容。
        7.3
        我们不会对你的用户内容主张任何所有权权利。请你注意，如果你以授权用户的身份使用本服务，我们会就你用户内容的使用方式向客户提供控制、限制、管理等诸多选择。例如，客户可启用或禁用其授权用户对本服务的访问权限，启用或禁用第三方服务，管理许可、保留和外传的设置等。企业用户的选择和决定可能会使你的部分或全部用户内容被访问、使用、披露、修改、限制使用或删除。如果你代表客户使用本服务，你确认客户将事先向其授权用户就此情况进行充分说明，并取得授权用户的明确同意。
        7.4
        本服务并非存储服务，针对你的内容，或其他用户向本服务或通过本服务上传、传播或提供的任何其他内容，我们不能亦不会提供备份。请注意，即使在你的用户内容从本服务中删除后，其他用户仍可能独立地继续使用及允许他人使用你的用户内容（例如，该用户可能已将你的用户内容的副本保存在其帐号中）。
        7.5 对于你的用户内容，以及向本服务或通过本服务发布、递交或传送该内容之后果，你须自行负全责。你亦同意不会向本服务递交任何违反适用法律与规定的内容或其他材料。
        7.6 你理解并同意，你查看他人在本服务提供的内容时，应自行判断并承担相关风险。未经相关权利人的明示同意，你不得为任何目的使用、复制、转载、传播、播放、展示、出售、许可或其他未明示允许的方式使用该等内容。

        <h3>
          8.数据隐私与安全
        </h3>
        8.1 <b>本服务之使用，受<a href='./privacy' className={styles.underLine}>《巡店助手隐私政策》</a>规范。</b>你使用本服务，即代表你已阅读、理解并接受该隐私政策全部条款。如果你未满18周岁，在使用本服务前，应在你的父母或其他监护人监护、指导下共同阅读并同意该隐私政策。
        8.2 <a href='./privacy' className={styles.underLine}>《巡店助手隐私政策》</a>可能会不时更新，以反映适用法律、法规、标准、行业规范等文件的更改，或反映本服务的更改、更新或新功能。<a href='./privacy' className={styles.underLine}>《巡店助手隐私政策》</a>有任何更新后，若你继续访问或使用本服务即代表你已阅读、理解并接受了这些更新。
        8.3 我们与你一同致力于你个人信息的保护，我们会在符合商业常理之范围内，尽力采取与本服务相匹配的技术措施或其他安全措施保护你的个人信息安全。尽管如此，我们无法保证你在网络上或通过网络进行信息传输的安全性或保密性。

        <h3>
          9.知识产权
        </h3>
        9.1
        <b > 你了解并同意，除非我们另有说明或相关权利人依照法律规定享有权利，否则本服务包含的非用户上传 / 提供的产品、技术、软件、程序、数据及其他所有信息内容，包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等（简称“巡店助手内容”）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密等）及相关权利均归我们或我们的关联公司所有。未经我们或相关权利人书面同意，你不得为任何商业或非商业目的自行或许可任何第三方使用（包括但不限于通过任何机器人、蜘蛛等程序或设备监视、复制、转载、散布、传播、播放、展示、出售、许可、镜像、上载、下载本服务中的内容）。</b >
        9.2 <b > 你应当和我们同样尊重知识产权。</b > 作为使用本服务的先决条件，你同意不会在使用本服务的过程中侵犯任何主体的知识产权（包括但不限于未经同意即擅自上传或分享他人受著作权法保护的材料）。

        <h3>
          10.违约与赔偿
        </h3>
        10.1
        如果你违反本协议和 / 或其他你应遵守的服务条款与规则，我们有权根据独立判断，视情况在不经事先通知你的情况下采取合理的处置措施，包括但不限于预先警示、限制、暂停、终止你使用本服务的部分或全部功能，屏蔽或删除你上传、传播或提供的内容、限制帐号部分或者全部功能、冻结或永久关闭帐号等，你需自行承担由此导致的后果及损失。我们有权公告处理结果并有权根据实际情况决定是否恢复相关帐号的使用，对已删除内容我们有权不予恢复或返还。<b>对涉嫌违反法律法规、涉嫌违法犯罪的行为，我们将保存有关记录，并有权依法向有关主管部门报告、配合有关主管部门调查、向公安机关报案等。</b>
        10.2
        如果你违反本协议和 / 或其他你应遵守的服务条款与规则，引起第三方投诉、诉讼索赔等情况的，你应当自行处理并承担全部法律责任。<b>若因你的违法或违约行为导致我们及我们的关联方、合作方等主体遭受任何损失（包括但不限于律师费用与支出）或行政处罚的，巡店助手除暂停或终止对您的服务，解除双方间的服务协议和法律关系外，无需退还您所支付的费用（如有），视为您支付的违约金，如违约金不足以弥补巡店助手的损失的，巡店助手还可通过其他法律途径向您追索。</b>

        <h3>
          11.有限担保
        </h3>
        11.1 你理解并同意，本服务是按照现有技术和条件所能达到的现状提供的。我们会尽最大努力向你提供连贯和安全的服务，但鉴于相关服务可能会受多种因素的影响或干扰，我们无法对包括但不限于下述内容进行保证：
        （1）你使用本服务将完全满足你的需求；
        （2）本服务连续不中断、即时、安全、无错误；
        （3）本服务中任何错误都将能得到更正；
        （4）本服务将与你的内容或我们未提供的任何其他硬件、软件、系统、服务或数据兼容。
        11.2 在法律允许范围内，除本协议明文约定外，我们无法向你进行任何保证、担保或承诺。我们可能在不通知你的情况下，随时为商业或营运需要，改变、中止、撤回或限制本服务的全部或部分功能。
        11.3
        我们将尽最大努力使本服务安全、稳定，但是你理解，我们不能随时预见和防范所有的技术或其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、基础运营商原因、电力供应故障、通讯网络故障、第三方服务瑕疵、系统更新与升级、政府部门调查、司法行政命令、第三方网站等原因可能导致的服务中断、数据丢失、不能正常使用以及其他类似情况。出现相应情况时，在条件允许的情况下，我们将努力在第一时间及时修复，但你同意，因上述原因产生的损失我们将免责，发生前述情况及基于该等原因取消或终止任何订单或服务的（如有且适用），不免除你在本协议下就我们已提供的服务部分履行相应付款义务。同时，你需要配置你自己的计算机设备、网络设置、计算机程序等，以使用本服务，你应为你的设备自行配置防毒程序。
        11.4 针对授权用户，在我方与客户间，你同意以下为客户之责任：
        （1）告知你可能会影响你使用本服务的相关客户政策；
        （2）在必要时，向你获取与客户权益及你使用本服务相关的授权；
        （3）基于客户组织管理需要，针对特定用户内容的转移与处理；
        （4）回复并解决任何与你或任何授权用户有关或源于与客户有关的用户信息，或是客户无法履行其义务所产生的争议或纠纷。

        <h3>
          12.责任限制
        </h3>
        12.1 在法律允许的范围内，针对下述情形，不论我们是否被告知或应察觉此类损害发生的可能，我们不会向你负有任何责任：
        12.1.1
        任何间接性、偶然性、后果性、惩罚性、特殊性或刑罚性的损害和损失承担责任，包括但不限于预期利益、商誉及信誉、机会、数据丢失及损失、第三方费用。除法律另有明确规定外，任何情况下，我们向你承担损失赔偿责任的金额上限为你发生损失或我们违约的月份，你已经向我们支付的当月服务费。在法律允许的最大范围内，这些限制和条款适用于与本协议相关的任何事项或任何索赔。
        12.1.2 任何因为以下原因对你造成的损失或损害：
        （1）你使用任何第三方产品或服务造成的损害；
        （2）我们以任何方式修改、暂停提供本服务或者本服务内任何功能；
        （3）你未向我们提供准确的帐号信息，或者你未按照本协议要求保护你的帐号密码安全；
        （4）其他因为你违反本协议约定的行为导致的损失。
        12.2
        在法律允许的最大范围内，你与任何第三方（包括但不限于例如任何移动网络服务商、权利所有者或其他用户）之间因你使用本服务而引起的任何争议都直接与你和该第三方相关，你必须排除我们对所有由此类争议引发的任何种类和性质的责任及损失（不论实际或间接）。

        <h3>
          13.费用
        </h3>
        13.1 在移动应用上使用本服务时可能会产生数据流量费、通讯费、信息费等，在国际漫游的情况下可能会使费用增加，这些费用均由你自行承担。若你不确定这些费用，你应在使用本服务前咨询你的服务提供商。
        13.2
        你知悉并理解，针对试用或其他暂不收费服务不应被视为我们放弃后续向你收费的权利。我们有权根据实际运营情况通过官方网站、公告或其他适当的方式通知你收费标准、方式或相关变更。如果你不同意上述修改、变更或付费内容，你可以选择停止使用该产品或服务。

        <h3>
          14.支持
        </h3>
        如果您对本用户服务协议有任何疑问，请联系我们：
        邮件：member @alphabets.cn
        官网：https://www.alphabets.cn/shoteyes
        电话：+86 186 4262 7048(Mrs.邵)
        + 86 134 7878 5024(Mr.沈)

        <h3>
          15.其他条款
        </h3 >
        15.1
        协议内容与修订：本协议内容包括本协议正文及所有我们已经发布或将来可能发布的隐私政策、各项规则、通知。前述内容均为本协议不可分割的组成部分，与本协议具有同等法律效力。为给你提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，我们会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会以适当的方式提醒你更新的内容，以便你及时了解本协议的最新版本，你也可以在网站首页或软件设置页面查阅最新版本的协议条款。如你对修订后的协议内容存有异议，你有权立即停止使用本服务。如你在修订协议生效日后继续使用本服务，即表示你已同意接受修订后的本协议内容。
        15.2
        适用法律与管辖：本协议的成立、生效、履行、解释及争议解决均应适用中华人民共和国大陆地区法律。如果本协议的任何约定被判决或裁定无效，则这些条款应在不违反法律的前提下，按照尽可能接近本协议原条款目的的原则进行重新解释和适用，且不影响本协议中其他条款的效力。
        15.3 本协议的签订地为中华人民共和国，因本协议所引发的争议双方应尽量友好协商解决，协商不成的，你同意将争议提交至本协议签订地有管辖权的人民法院解决。
        15.4
        未经我们事先书面同意，你不得向任何第三方转让你在本条款项下的任何权利或义务。你理解并同意，我们有权自主决定经营策略并根据业务调整情况将本协议项下的全部权利义务一并转移给我们的关联公司或其他法律主体，你认可在上述情况下，我们无须征得你的同意，我们将尽量以合理的方式向你通知。
        15.5 我们暂时未主张或强制执行本协议的任何约定，不应被视为我们豁免该等约定或放弃该等权利。
        15.6 本协议中的标题仅为方便及阅读而设，并不影响本协议中任何规定的含义或解释。
        <div>
          发布时间：2023年05月23日
          更新日期：2023年05月23日
          生效日期：2023年05月23日
        </div>
      </div>
    </Base.Layout >
  );
}
